import './Destination.css'

const DestinationItem = props => {

  const {destinationDetails} = props
  const {imageURL, name, description, id} = destinationDetails
  return (
    <div className="destination-item-container">
      <div>
        <div className="image-container">
          <img
            className="destination-item-image"
            src={imageURL}
            alt={`project-item${id}`}
          />
          <button type="button" className="r-button">
            <img
              src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693663285/Vector_q4arlk.png"
              alt="star"
            />
            4.8
          </button>
          <button type="button" className="exclusive">
            EXCLUSIVE
          </button>
        </div>
        <h4>{name}</h4>
        <p className="p-desc">{description}</p>
      </div>
    </div>
  )
}

export default DestinationItem